"use strict";

var _classCallCheck = require("/home/runner/work/frontend-app/frontend-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/frontend-app/frontend-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@walletconnect/utils");

var SessionStorage = /*#__PURE__*/function () {
  function SessionStorage() {
    _classCallCheck(this, SessionStorage);

    this.storageId = "walletconnect";
  }

  _createClass(SessionStorage, [{
    key: "getSession",
    value: function getSession() {
      var session = null;
      var json = utils_1.getLocal(this.storageId);

      if (json && utils_1.isWalletConnectSession(json)) {
        session = json;
      }

      return session;
    }
  }, {
    key: "setSession",
    value: function setSession(session) {
      utils_1.setLocal(this.storageId, session);
      return session;
    }
  }, {
    key: "removeSession",
    value: function removeSession() {
      utils_1.removeLocal(this.storageId);
    }
  }]);

  return SessionStorage;
}();

exports.default = SessionStorage;